module.exports = __webpack_public_path__ + "project.e08ae9df.png";